export default "__VITE_ASSET__h8WA99iq__"